import React from 'react';
import { theme } from '@fiverr-private/theme';
import { SYSTEM_ICON_SIZES } from '../../constants';
import type { SystemIconType } from '../../types';

const PinIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill={theme.colors[color]}
    viewBox="0 0 13 16"
  >
    <path
      fillRule="evenodd"
      d="M6.133 1.75A4.383 4.383 0 0 0 1.75 6.133c0 1.837 1.146 3.883 2.414 5.555a23 23 0 0 0 1.97 2.266l.26-.267a23 23 0 0 0 1.708-1.999c1.27-1.672 2.415-3.718 2.415-5.555A4.383 4.383 0 0 0 6.133 1.75m0 13.25-.504.555-.002-.002-.004-.003-.013-.012-.047-.044-.172-.164a24.894 24.894 0 0 1-2.422-2.735C1.671 10.884.25 8.496.25 6.133a5.883 5.883 0 0 1 11.767 0c0 2.363-1.421 4.75-2.72 6.462a25 25 0 0 1-2.593 2.899l-.047.044-.013.012-.004.003-.001.001s-.001.001-.506-.554m0 0 .506.554a.75.75 0 0 1-1.01 0zm0-10.45a1.583 1.583 0 1 0 0 3.167 1.583 1.583 0 0 0 0-3.167M3.05 6.133a3.083 3.083 0 1 1 6.167 0 3.083 3.083 0 0 1-6.167 0"
      clipRule="evenodd"
    />
  </svg>
);
PinIcon.id = 'PinIcon';
PinIcon.displayName = 'PinIcon';
export default PinIcon;
